module.exports = __webpack_public_path__ + "img/images.63b65509.png";